<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col class="Full-Course-Library-Title"> Groups </v-col>
      </v-row>
      <v-row class="sm-mt-20">
        <v-col cols="12" sm="4">
          <v-text-field class="search-box" placeholder="Search Groups" prepend-icon="fa-search" v-model="search"
            type="text" clearable clear-icon="fa-times" @click:clear="resetSearch" @change="applySearch"></v-text-field>
        </v-col>
        <v-col cols="12" sm="7" class="sm-mt-10">
          <v-btn color="primary" outlined @click.prevent="showCreatePanel" class="add-course-button">
            Add New Group
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table"
              :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table"
              :types="{ 'table-heading': '', 'table-thead': 'heading@1', 'table-row': 'text@1' }"
              class="slider-table"></v-skeleton-loader>
            <v-data-table :headers="headers" :options.sync="options" :server-items-length="serverItemsLength"
              :items="groups" :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }" v-show="!loading">
              <template v-slot:item.name="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="text-wrap-30">
                      {{ formatTextByWords(item.name) }}
                    </div>
                  </template>
                  <span>{{ formatTextByWords(item.name) }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.description="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div class="truncate-text" v-on="on">
                      {{ item.description }}
                    </div>
                  </template>
                  <span>{{ item.description }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.id="{ item }">
                <v-select v-if="screenSize === 'tablet' || screenSize === 'mobile'" v-model="selectedActions"
                  :items="getActionList(item)" item-text="name" item-value="id" placeholder="Select Action"
                  @change="performAction(item)" :item-disabled="action => action.is_course_archived"></v-select>

                <template v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="mr-4 action-button action-button-txt" small outlined
                        @click.prevent="showEditPanel(item.id)">
                        Edit
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" @click.prevent="showAssignUsersPanel(item.id)"
                        class="mr-4 action-button action-button-txt" outlined small>
                        Users
                      </v-btn>
                    </template>
                    <span>Manage Users</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small text color="$improve-grey-900" @click.prevent="deleteGroup(item.id)"
                        class="Frame-61">
                        <v-icon small>fa fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Group</span>
                  </v-tooltip>
                </template>

              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import GroupAPI from '@/api/group.js';
import LayoutBasic from '@/layouts/Dashboard';
import EditGroup from '@/components/admin/groups/Edit';
import CreateGroup from '@/components/admin/groups/Create';
import AssignUsers from '@/components/admin/groups/Assign';
import ViewDetails from '@/components/admin/groups/View';
import companyAPI from '@/api/company.js';
import { screensize } from '../../utils/screensize';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  components: {
    LayoutBasic,
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
    this.screenSize = null;
  },
  data() {
    return {
      selectedActions: null,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Users', value: 'total_users', sortable: false },
        { text: 'Actions', value: 'id', sortable: false, align: 'left' },
      ],
      screenSize: currentScreenSize,
      groups: [],
      pagination: {},
      options: {},
      loading: false,
      search: '',
      searchParams: '',
      confirmDelete:
        'Are you sure you wish to delete this group? Deleting this group will remove all users from playlists and courses associated with this group.',
      locations: [],
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options) + this.searchParams;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getGroups();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
    this.getCompanySites();
    this.handleResize();

    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    getActionList(item) {
      let actions = [
        {
          name: 'Edit',
          action: () => this.showEditPanel(item.id),
        },
        {
          name: 'Users',
          action: () => this.showAssignUsersPanel(item.id),
        },
        {
          name: 'Delete',
          action: () => this.deleteGroup(item.id),
        },

      ];
      return actions;
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedActions
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
       this.selectedActions = null;
      }, 0);
    },
    // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    formatTextByWords(text) {
      return text || '';
    },
    resetSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.getGroups();
    },
    applySearch() {
      this.options.page = 1;
      this.searchParams =
        this.search != null
          ? this.params + '&search=name:' + this.search
          : this.params;
      this.getGroups();
    },
    getGroups() {
      this.loading = true;
      GroupAPI.getGroups(this.params, '').then((resp) => {
        this.loading = false;
        this.groups = resp.data.data;
        this.pagination = resp.data.meta.pagination;
      });
    },
    deleteGroup(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.deleteGroupProcess(toast, id)
          }
        ],
      });
    },
    deleteGroupProcess(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      GroupAPI.deleteGroup(id).then((resp) => {
        this.loading = false;
        this.getGroups();
      });
    },
    applyGroupSearch() {
      this.groupSearchParams =
        this.groupParams + '&search=name:' + this.groupSearch;
      this.getGroups();
    },
    setEventBus() {
      EventBus.$on('GROUPS_UPDATED', (payload) => {
        // this.params = payload;
        this.getGroups();
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditGroup,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showAssignUsersPanel(id) {
      this.$showPanel({
        component: AssignUsers,
        props: {
          id: id,
          params: this.params,
          locations: this.locations
        },
        openOn: 'right',
      });
    },
    showDetailsPanel(id) {
      this.$showPanel({
        component: ViewDetails,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateGroup,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    getCompanySites() {
      companyAPI.getCompanySites().then(response => {
        this.locations = response.data.data;
      });
    },


  },
};
</script>

<style scoped>
.text-wrap-30 {
  word-break: normal;
  overflow-wrap: anywhere;
}

</style>
